// services/tokenService.ts
import axios from 'axios'
import { store } from '../store/store'
import { clearToken, setRefreshing, setToken } from '../store/slices/inmutable'
import { AuthenticationServices } from './AuthenticationServices'

export const initializeToken = async () => {
  try {
    store.dispatch(setRefreshing(true))
    const token = await AuthenticationServices()
    if (typeof token !== 'string') {
      throw new Error('Invalid token received')
    }
    // Asume que el token expira en 30 minutos (1800 segundos)
    store.dispatch(setToken({ token, expiresIn: 1800 }))
    return token
  } catch (error) {
    store.dispatch(clearToken())
    throw error
  } finally {
    store.dispatch(setRefreshing(false))
  }
}

export const getCurrentToken = async (): Promise<string> => {
  const state = store.getState()
  const { token, tokenExpiration, isRefreshing } = state.inmutable

  // Si no hay token o está a punto de expirar (menos de 5 minutos) y no se está refrescando
  const isExpired = tokenExpiration && tokenExpiration - Date.now() < 300000

  if ((!token || isExpired) && !isRefreshing) {
    return await initializeToken()
  }

  if (!token) {
    throw new Error('No authentication token available')
  }

  return token
}

// Configuración de axios para usar el token
axios.interceptors.request.use(
  async (config) => {
    if (config.url?.includes('Authentication')) {
      return config // No agregar token a las peticiones de autenticación
    }

    try {
      const token = await getCurrentToken()
      config.headers.Authorization = `Bearer ${token}`
    } catch (error) {
      console.error('Error getting token:', error)
      // Puedes manejar el error aquí o dejar que se propague
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
